import { render, staticRenderFns } from "./CollapsableComponent.vue?vue&type=template&id=77595ada&scoped=true"
import script from "./CollapsableComponent.vue?vue&type=script&lang=js"
export * from "./CollapsableComponent.vue?vue&type=script&lang=js"
import style0 from "./CollapsableComponent.vue?vue&type=style&index=0&id=77595ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77595ada",
  null
  
)

export default component.exports